import React, { Component } from 'react';
import Hero from './Hero';
import Slick from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

class HeroCarousel extends Component {
  render() {
    const { carouselItems } = this.props;
    const settings = {
      autoplay: true,
      autoplaySpeed: 7500,
      pauseOnHover: false,
      dots: false,
      fade: true,
      arrows: false,
      infinite: true,
      speed: 900,
      slidesToShow: 1,
      slidesToScroll: 1,
      cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
      draggable: false,
      touchThreshold: 100
    };
    return (
      <section className="is-hero-carousel">
        <Slick {...settings}>
          {carouselItems.map(item => (
            <div className="is-carousel-item" key={item.id}>
              <Hero isInCarousel={true} isFull={true} {...item} />
            </div>
          ))}
        </Slick>
      </section>
    );
  }
}

export default HeroCarousel;



// WEBPACK FOOTER //
// ./src/components/HeroCarousel.js